import React from 'react';

// FIX-38: reusable error-state card, styled to match the existing root
// app/error.tsx (slate card + emerald "Try again" action) so segment-level
// error.tsx files render something visually consistent with the rest of the
// app instead of a bare error message.
export function ErrorCard({
  title = 'Something went wrong',
  message,
  onRetry,
}: {
  title?: string;
  message?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="w-full max-w-xl rounded-2xl border border-slate-800 bg-slate-950/70 p-6 shadow-2xl">
      <h2 className="text-xl font-semibold text-slate-100">{title}</h2>
      <p className="mt-2 text-sm text-slate-300">
        {message || 'Please try again. If this keeps happening, come back later.'}
      </p>
      {onRetry && (
        <div className="mt-5">
          <button
            type="button"
            onClick={onRetry}
            className="inline-flex items-center justify-center rounded-full bg-emerald-500 px-4 py-2 text-sm font-semibold text-slate-950 hover:bg-emerald-400"
          >
            Try again
          </button>
        </div>
      )}
    </div>
  );
}

export default ErrorCard;
